<template>
  <div class="custom" @click="contactService">
    <span>在线人工客服</span>
    <span class="icon icon-service">
      <span class="path1"></span>
      <span class="path2"></span>
      <span class="path3"></span>
    </span>
  </div>
</template>

<script>
import native from '@/utils'

const { NativeFuncs, callNativeAsyncFunc } = native

export default {
  methods: {
    contactService() {
      callNativeAsyncFunc(NativeFuncs.NAVIGATION.CUSTOMER_SERVICE).then(() => {
        // 跳转客服页面
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../style/func.scss';

.custom {
  position: absolute;
  left: px2rem(8px);
  bottom: px2rem(4px);
  display: flex;
  justify-content: space-between;
  width: 85%;
  color: #63c4f8;
  padding: px2rem(8px) px2rem(18px);
  line-height: px2rem(29px);
  background-color: #fff;
  box-shadow: 0 0 5px 3px #e0e0e0;
  border-radius: 4px;
  z-index: 1;

  .icon {
    display: inline-block;
    width: px2rem(28px);
    font-size: px2rem(28px);

    .path1,
    .path2,
    .path3 {
      float: left;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help-center/components/CustomService.vue